import { API } from 'aws-amplify';

class HistoryService {

    deleteOldFlightsAndUploadedFiles = async () => {      
        return API.post('IAPI', 'History/DeleteOldFlightsAndUploadedFiles/')
            .then((res) => {
                return res;
            }).catch((error) => {
                return error;
            });
    }   
}

export default new HistoryService();